// 特种箱散杂案例API接口
import {http} from '@/utils/index'

// 获取案例列表
export const getCaseList = (language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/special-container-case/list", {
    params
  })
}

// 获取案例详情
export const getCaseDetail = (id, language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", `/special-container-case/detail/${id}`, {
    params
  })
}

// 获取相关案例推荐
export const getRelatedCases = (currentId, language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", `/special-container-case/related/${currentId}`, {
    params
  })
}
